import { registerTacticalPlugin } from "./registry";

registerTacticalPlugin({
  id: "measure",
  label: "Измерение",
  description: "Длина, площадь, круг, координаты точки; азимут сегмента линии.",
  activate: () => () => undefined,
});

export {};
